import React, { useRef, useState, useContext } from "react";
import AssetRegisterDrawer from "./AssetRegisterDrawer";
import { JWT } from "../../../constants/local-storage";

export default function ScreenCapturePanelAssetFinder({assets, hasCoordinates, getConditionColour, hoveredId, setHoveredId}) {
		
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [selectedAssetId, setSelectedAssetId] = useState(null);
	
	
	
	function generateReport()
	{
	    

	    fetch("/resolutionsoftwareplatform/ai/report/asset",
	    {
	        method: "GET",
	        headers:
	        {
	            Authorization: "Bearer " + localStorage.getItem(JWT)
	        }
	    })
	    .then(function(response)
	    {
	        if (!response.ok)
	        {
	            throw new Error("Failed to generate report");
	        }

	        return response.blob();
	    })
	    .then(function(blob)
	    {
	        const url = window.URL.createObjectURL(blob);

	        const link = document.createElement("a");

	        link.href = url;
	        link.download = "OmniScan_Asset_Report.pdf";

	        document.body.appendChild(link);

	        link.click();

	        document.body.removeChild(link);

	        window.URL.revokeObjectURL(url);

	       
	    })
	    .catch(function(error)
	    {
	        console.error(error);

	        
	    });
	}
		return (
			<>
                   <div style={{
                       width: "360px",
                       background: "#111",
                       color: "#fff",
                       padding: "20px",
                       overflowY: "auto",
					   boxShadow: "-12px 0 24px rgba(0,0,0,.35)",
					   zIndex: 20
                   }}>

                       <div style={{ fontSize: "20px", marginBottom: "4px" }}>
                           Detected Assets
                       </div>

                       <div style={{ fontSize: "12px", color: "#888", marginBottom: "18px" }}>
                           AI generated asset and condition assessment
                       </div>
					   
					   
					   <div
					       style={{
					           display: "flex",
					           gap: "10px",
					           marginBottom: "20px"
					       }}
					   >

					       <button
					           onClick={function()
					           {
					               setDrawerOpen(true);
					           }}
					           style={{
					               flex: 1,
					               background: "#5a9bd6",
					               color: "#fff",
					               border: "none",
					               borderRadius: "8px",
					               padding: "12px",
					               cursor: "pointer",
					               fontWeight: "bold",
					               fontSize: "14px"
					           }}
					       >
					           Populate Asset Register ({assets.length})
					       </button>

						   <button
						       onClick={generateReport}
						       style={{
						           flex: 1,
						           background: "#2e7d32",
						           color: "#fff",
						           border: "none",
						           borderRadius: "8px",
						           padding: "12px",
						           cursor: "pointer",
						           fontWeight: "bold",
						           fontSize: "14px"
						       }}
						   >
						       📄 Generate Report
						   </button>

					   </div>

                       {assets.length === 0 && (
                           <div style={{ color: "#999", fontSize: "13px" }}>
                               No assets detected.
                           </div>
                       )}

					   {assets.map(function (a)
					   {
					       const colour = getConditionColour(a.condition, a.type);

					       return (
					           <div
					               key={a.id}
					               onClick={function ()
					               {
					                   setSelectedAssetId(a.id);
					               }}
					               onMouseEnter={function ()
					               {
					                   setHoveredId(a.id);
					               }}
					               onMouseLeave={function ()
					               {
					                   setHoveredId(null);
					               }}
					               style={{
					                   padding: "12px",
					                   marginBottom: "10px",
					                   borderRadius: "10px",
					                   cursor: "pointer",
					                   transition: "all .2s ease",

					                   border:
					                       selectedAssetId === a.id
					                           ? "2px solid #5a9bd6"
					                           : "2px solid transparent",

					                   background:
					                       selectedAssetId === a.id
					                           ? "rgba(90,155,214,.12)"
					                           : hoveredId === a.id
					                               ? "#1a1a1a"
					                               : "transparent",

					                   boxShadow:
					                       selectedAssetId === a.id
					                           ? "0 0 12px rgba(90,155,214,.35)"
					                           : "none",

					                   borderBottom:
					                       selectedAssetId === a.id
					                           ? "2px solid #5a9bd6"
					                           : "1px solid #333"
					               }}
					           >
					               <div
					                   style={{
					                       display: "flex",
					                       gap: "12px",
					                       alignItems: "flex-start"
					                   }}
					               >
					                   {a.thumbnail &&
					                   (
					                       <img
					                           src={a.thumbnail}
					                           alt=""
											   style={{
											       width: "70px",
											       height: "50px",
											       objectFit: "cover",
											       borderRadius: "6px",
											       border: "1px solid #333",
											       flexShrink: 0,
											       cursor: "zoom-in"
											   }}
					                       />
					                   )}

					                   <div style={{ flex: 1 }}>

					                       <div
					                           style={{
					                               display: "flex",
					                               justifyContent: "space-between",
					                               alignItems: "center"
					                           }}
					                       >
					                           <div
					                               style={{
					                                   fontWeight: "bold",
					                                   color: hoveredId === a.id ? "#5a9bd6" : "#fff"
					                               }}
					                           >
					                               {a.type}
					                           </div>

					                           <div
					                               style={{
					                                   fontSize: "11px",
					                                   color: "#aaa",
					                                   whiteSpace: "nowrap"
					                               }}
					                           >
					                               {Math.round(a.confidence * 100)}%
					                           </div>
					                       </div>

					                       {a.condition && (
					                           <div
					                               style={{
					                                   display: "inline-block",
					                                   marginTop: "8px",
					                                   padding: "3px 8px",
					                                   borderRadius: "999px",
					                                   background: colour + "22",
					                                   color: colour,
					                                   fontSize: "12px",
					                                   fontWeight: "bold"
					                               }}
					                           >
					                               {a.condition}
					                           </div>
					                       )}

					                       {a.observation && (
					                           <div
					                               style={{
					                                   marginTop: "8px",
					                                   fontSize: "12px",
					                                   color: "#ccc",
					                                   lineHeight: "1.4"
					                               }}
					                           >
					                               {a.observation}
					                           </div>
					                       )}

					                       {a.recommendation && (
					                           <div
					                               style={{
					                                   marginTop: "8px",
					                                   fontSize: "12px",
					                                   color: "#9bcfff",
					                                   lineHeight: "1.4"
					                               }}
					                           >
					                               Recommendation: {a.recommendation}
					                           </div>
					                       )}

					                       {!hasCoordinates(a) && (
					                           <div
					                               style={{
					                                   marginTop: "8px",
					                                   fontSize: "11px",
					                                   color: "#666"
					                               }}
					                           >
					                               No hotspot coordinates returned
					                           </div>
					                       )}

					                   </div>

					               </div>
					           </div>
					       );
					   })}

                   </div>
				   <AssetRegisterDrawer
				         open={drawerOpen}
				         assets={assets}
				         onClose={function()
				         {
				             setDrawerOpen(false);
				         }}
				     />

				     </>
				  );
}